export type Modifier = 'meta' | 'ctrl';

export interface Hotkey {
  key: string; // single character, e.g. 'o'
  modifier: 'metaOrCtrl';
}

export const SWITCHER_HOTKEY: Hotkey = {
  key: 'o',
  modifier: 'metaOrCtrl',
};

export function isSwitcherShortcut(e: KeyboardEvent): boolean {
  const k = e.key?.toLowerCase();
  if (!k) return false;
  const isMac = typeof navigator !== 'undefined' && /mac|ipad|iphone|ipod/i.test(navigator.platform ?? '');
  const mod = isMac ? e.metaKey : e.ctrlKey;
  return mod && k === SWITCHER_HOTKEY.key;
}

export function getSwitcherModifierLabel(): Modifier {
  const isMac = typeof navigator !== 'undefined' && /mac|ipad|iphone|ipod/i.test(navigator.platform ?? '');
  return isMac ? 'meta' : 'ctrl';
}

